import { useCallback, useState } from 'react';
import { dotnetBackendApiUrl } from '../config/dotnetBackendEnv';
import { useAuthHeader } from './getAuthHeader';

// PUT /api/users/preferences/theme is the replacement for the legacy
// users/updateuser endpoint. Identity is derived from the JWT `sub` claim on
// the server; the caller only needs to supply the new theme value.
const useUpdateThemePreference = () => {
    const apiUrl = dotnetBackendApiUrl;
    const [isSuccess, setIsSuccess] = useState(false);
    const [isError, setIsError] = useState(false);
    const getAuthHeader = useAuthHeader('AppUser', 'PUT');

    const updateThemePreference = useCallback(async (themePreference: 'light' | 'dark') => {
        const authHeader = await getAuthHeader();
        const response = await fetch(`${apiUrl}users/preferences/theme`, {
            ...authHeader,
            body: JSON.stringify({ ThemePreference: themePreference }),
        });

        if (response.ok) {
            setIsSuccess(true);
            setIsError(false);
        } else {
            setIsError(true);
            setIsSuccess(false);
        }
        return response.ok;
    }, [getAuthHeader, apiUrl]);

    return { isSuccess, isError, updateThemePreference };
};

export default useUpdateThemePreference;
